import React from 'react';

import AdjustmentsAndDiscounts from './AdjustmentsAndDiscounts';
import PaymentsSummary from './PaymentsSummary';
import SummaryItem from './SummaryItem';
import TaxesAndFees from './TaxesAndFees';

const InvoiceSummary = ({
  preview,
  total,
  subTotal,
  technologyFee,
  onTechnologyFeeToggle,
  isSurchargeApplied,
  stateTax,
  localTax,
  discount,
  writeOffs,
  otherAdjustments,
  insuranceAdjustments,
  insuranceBalance,
  tax,
  hideSwitch,
  patientPaid,
  insurancePaid,
  isAEOB,
  isGFE = false
}) => {
  const estimatedLabel = isGFE && isAEOB ? ' (Estimated)' : '';

  return (
    <div className="print-avoid-break-inside flex w-full justify-end bg-white p-6 sm:px-2 print:pr-5">
      <div className="flex w-full max-w-[480px] flex-col border-0 border-b border-solid border-b-neutral-900 px-0 pb-1 pt-0">
        <SummaryItem label="Subtotal" value={subTotal} />
        <AdjustmentsAndDiscounts
          isAEOB={isAEOB}
          preview={preview}
          discount={discount}
          writeOffs={writeOffs}
          estimatedLabel={estimatedLabel}
          otherAdjustments={otherAdjustments}
          insuranceAdjustments={insuranceAdjustments}
          insuranceBalance={insuranceBalance}
        />
        <TaxesAndFees
          preview={preview}
          onTechnologyFeeToggle={onTechnologyFeeToggle}
          isSurchargeApplied={isSurchargeApplied}
          technologyFee={technologyFee}
          stateTax={stateTax}
          localTax={localTax}
          tax={tax}
          hideSwitch={hideSwitch}
        />
        <PaymentsSummary
          isAEOB={isAEOB}
          preview={preview}
          patientPaid={patientPaid}
          insurancePaid={insurancePaid}
          estimatedLabel={estimatedLabel}
        />
        <div className="mt-2 flex h-[44px] w-full items-center border-0 border-b border-solid border-b-neutral-900 px-0 py-1">
          <SummaryItem label="Amount due" value={total} color="neutral-900" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummary;
